import React, { useEffect, useRef, useState } from 'react'
import Logo from '../Logo/Logo';
import { Link } from 'react-router-dom';
import blueLogo from "../../assets/blueLogo.svg";

import back from "../../assets/back-arrow.svg";
import next from "../../assets/forward-arrow.svg";
import PlanForMeForm from './PlanForMeForm';
import { Helmet } from 'react-helmet-async';

const planForMe= [
  {
    sn: 1,
    name: "Verified, trusted planners and vendors",
    title: "Every planner and vendor we recommend has been carefully vetted for quality, reliability, and professionalism. You can be confident that whoever we connect you with has a proven track record of delivering great results and making clients happy.",
  },
  {
    sn: 2,
    name: "Personalized event guidance — not generic listings.",
    title:"We don’t just hand you a random list of vendors. Our team takes time to understand your event type, style, and budget, then connects you with the right professionals who fit your exact needs — so you get a truly personalized experience.",
  },
  {
    sn: 3,
    name: "Transparent process and simple pricing",
    title: "No hidden fees, no confusion. Submitting your request is completely free. Once we review your event details and speak with you, any applicable fees or service costs will be explained clearly before you move forward. This ensures you understand exactly what you’re paying for and can make informed decisions with confidence.",
  },
];



const PlanForMe = () => {
  const [showForm, setShowForm] = useState(false);
  const [page, setPage] = useState(0);
  const [formData, setFormData] = useState({
    details: "",
  });
  const [currentStep, setCurrentStep] = useState(1);
  const [isComplete, setIsComplete] = useState(false);
  const [margins, setMargins] = useState({
    marginLeft: 0,
    marginRight: 0,
  });
  const stepRef = useRef([]);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

   useEffect(() => {
      if (stepRef.current.length > 0) {
        setMargins({
          marginLeft: stepRef.current[0]?.offsetWidth / 2 || 0,
          marginRight:
            stepRef.current[stepRef.current.length - 1]?.offsetWidth / 2 || 0,
        });
      }
    }, [stepRef.current]);
  
    const handleNext = () => {
      setShowForm(true);
    };
  
    const handleSubmit = () => {
      console.log('Plan for me Request:', formData);
      setSubmitted(true);
    };
  
    const handlePrevious = () => {
      setShowForm(false);
    };

  return (

    <>
    <Helmet>
        <title>Your Perfect Event, Matched and Managed</title>
        <meta name="description" content="Let Quickplanners match you with verified planners and vendors who fit your event goals, style, and budget — we handle the search, you enjoy the results." />
    </Helmet>
    <div className="content">
      <section className="d-flex vendor-registeration">
        <div className="side">
          <div className="logo">
            <Logo />
          </div>

          <h2 className="sub-head">Why Choose “Plan For Me”</h2>

          <div className="register-reason">
            <div>
               {planForMe.map((item) => (
                <div className="reason-item d-flex gap-3" key={item.sn}>
                  <div className="reason-icon">
                    <p className="sn">{item.sn}</p>
                  </div>
                  <div className="reason-items">
                    <p className="">{item.name}</p>
                    <span className="">{item.title}</span>
                  </div>
                </div>
              ))}{" "}
            </div>
          </div>
        </div>

        <div className="main">
          <Link to="/">
            <img src={blueLogo} alt="Logo" className="blue-logo" />
          </Link>

          <h2 className="main-head">Plan For Me</h2>
           <p className="sub-para">
            <strong>
              Let Us Handle the Stress, You Focus on the Celebration.
            </strong>
              
            </p>
           {submitted ? (
            <div>
              <p className="sub-para">Request submitted successfully!</p>
              <p className="sub-para">Our support team will reach out within 24–48 hours to share curated venue options that fit your request.</p>
            </div>
          ) : (
            <>
            {!showForm ? (
              <>
                  <p className="sub-para">
                      Planning an event should be exciting, not overwhelming. From finding the right vendors to coordinating details and timelines, it’s easy to feel stretched. With <strong>Quickplanners</strong>, you don’t have to handle it alone.
                     </p>
                  <p className="sub-para">
                    Simply submit your event brief and tell us what you’re planning. A
                     <strong>{" "}
                        Quickplanners customer support representative
                      </strong> {" "}
                        will reach out shortly to understand your vision, requirements, and budget.
                     </p>
                  <p className="sub-para">
                      From there, we’ll guide you through the next steps and connect you with a trusted planner that fits your needs. <strong>{" "}There’s no payment required to submit your request{" "}</strong>— any fees, if applicable, will be discussed clearly after we review your event details. The goal is a smooth, personal planning experience that saves you time, reduces stress, and gives you confidence from the start.
                  </p>
              </>
            ) : (
              <PlanForMeForm formData={formData} setFormData={setFormData} />
            )}
            </>
          )}    
          {/* Form details */}

         <div className="">
           
            <div className="form-container">
             
              <div className="">
                <div className="d-flex justify-content-between align-items-center stepper-nav">
                  {showForm && !submitted && (
                    <button
                      className="step-btn btn-ghost d-flex align-items-center gap-3"
                      onClick={handlePrevious}
                    >
                      <span>
                        <img src={back} alt="previous step arrow" />
                      </span>
                      Back
                    </button>
                  )}
                  <div></div>

                  {submitted && (
                    <Link to="/">
                      <button
                        className={`step-btn btn-full d-flex align-items-center gap-3 complete`}
                      >
                        Done
                      </button>
                    </Link>
                  )}
                  {!isComplete && !submitted && (
                    <>
                      {showForm ? (
                        <button
                          className="step-btn btn-full d-flex align-items-center gap-3 complete"
                          onClick={handleSubmit}
                          disabled={!formData.agreeToFee}
                        >
                          {!loading && "Submit"}{" "}
                          {loading && (
                            <div
                              className="spinner-border text-light"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          )}
                        </button>
                      ) : (
                        <button
                          className="step-btn btn-full d-flex align-items-center gap-3"
                          onClick={handleNext}
                        >
                          Next{" "}
                          <span>
                            <img src={next} alt="next step arrow" />
                          </span>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    </>
    
  );
}

export default PlanForMe
